import { FirebaseAuth } from '@/auth/adapters/FirebaseAuth';
import { OryAuth } from '@/auth/adapters/OryAuth';
import type { AuthProvider } from './AuthProvider';

export type AuthProviderName = 'firebase' | 'ory';

export function getAuthProviderName(): AuthProviderName {
  const name: AuthProviderName = import.meta.env.VITE_AUTH_PROVIDER;

  if (name === 'firebase' || name === 'ory') return name;

  throw new Error(`Invalid VITE_AUTH_PROVIDER: ${String(name)}`);
}

let instance: AuthProvider | null;

export function getAuthProvider(): AuthProvider {
  if (!instance) {
    instance = getAuthProviderName() === 'ory' ? new OryAuth() : new FirebaseAuth();
  }
  return instance;
}

export const resetAuthProvider = () => {
  instance = null;
};
